import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';

interface ReviewStatusControlProps {
  isReviewed: boolean;
  canToggle?: boolean;
  isBusy?: boolean;
  className?: string;
  onToggle?: React.MouseEventHandler<HTMLButtonElement>;
  reviewedLabel?: string;
  unreviewedLabel?: string;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  testId?: string;
}

export const ReviewStatusControl: React.FC<ReviewStatusControlProps> = ({
  isReviewed,
  canToggle = false,
  isBusy = false,
  className,
  onToggle,
  reviewedLabel = 'Clear review',
  unreviewedLabel = 'Mark reviewed',
  reviewedBy,
  reviewedAt,
  testId,
}) => {
  const label = isReviewed ? reviewedLabel : unreviewedLabel;
  const stateClass = isReviewed ? 'is-reviewed' : 'is-unreviewed';
  const reviewMetadata =
    isReviewed && reviewedBy
      ? `Reviewed by ${reviewedBy}${reviewedAt ? ` at ${reviewedAt}` : ''}`
      : isReviewed
        ? 'Reviewed'
        : 'Not reviewed';
  const controlTitle = `${label}. ${reviewMetadata}`;
  const classes = ['dg-review-icon-button', stateClass, isBusy ? 'is-busy' : '', className]
    .filter(Boolean)
    .join(' ');

  if (canToggle && onToggle) {
    return (
      <button
        type="button"
        className={classes}
        aria-label={label}
        aria-pressed={isReviewed}
        title={controlTitle}
        disabled={isBusy}
        data-testid={testId}
        onClick={onToggle}
      >
        <CheckCircleIcon className={isBusy ? 'is-spinning' : ''} />
      </button>
    );
  }

  return (
    <span
      className={['dg-review-status-icon', stateClass, className].filter(Boolean).join(' ')}
      role="img"
      aria-label={isReviewed ? 'Reviewed' : 'Not reviewed'}
      title={reviewMetadata}
      data-testid={testId}
    >
      <CheckCircleIcon />
    </span>
  );
};
